import { Button } from "@mui/material";

import HNSColors from "../../../../ui library/HNSColors";

function PaymentsButton({ children, disabled, onClick, variant = "contained" }) {
  const isOutlined = variant === "outlined";
  const muiVariant = isOutlined ? "outlined" : "contained";

  return (
    <Button
      className="w-1/2"
      disabled={disabled}
      onClick={onClick}
      variant={muiVariant}
      sx={{
        textTransform: "none",
        borderRadius: "500px",
        paddingY: "6px",
        boxShadow: "none",
        border: isOutlined ? "1px solid" : "none",
        backgroundColor: isOutlined
          ? HNSColors.neutrals[900]
          : disabled
            ? HNSColors.neutrals[800]
            : HNSColors.secondary[500],
        color: isOutlined
          ? HNSColors.secondary[500]
          : disabled
            ? HNSColors.neutrals[500]
            : HNSColors.neutrals[900],
        borderColor: isOutlined ? HNSColors.secondary[500] : "transparent",
        "&:hover": {
          boxShadow: "none",
          backgroundColor: isOutlined ? HNSColors.secondary[900] : HNSColors.secondary[600],
          color: isOutlined ? HNSColors.secondary[500] : HNSColors.neutrals[900],
          borderColor: isOutlined ? HNSColors.neutrals[900] : "transparent",
        },
      }}
    >
      {children}
    </Button>
  );
}

export default function PaymentsActionButtons(props) {
  const {
    disableSave,
    handleOnClickSaveButton,
    disableCancel,
    handleOnClickCancelBtn,
    cancelLabel = "Cancel",
    saveLabel = "Save",
  } = props;

  return (
    <div className="flex w-1/2 flex-row justify-end gap-2 px-2 py-4">
      <PaymentsButton disabled={disableCancel} onClick={handleOnClickCancelBtn} variant="outlined">
        {cancelLabel}
      </PaymentsButton>
      <PaymentsButton disabled={disableSave} onClick={handleOnClickSaveButton}>
        {saveLabel}
      </PaymentsButton>
    </div>
  );
}
